import { AiOutlineExclamationCircle } from 'react-icons/ai';

import styled from 'styled-components';

import { ReactComponent as ArrowForw } from 'assets/images/arrow-forw.svg';
import { ReactComponent as ArrowTransfer } from 'assets/images/arrow-transfer.svg';
import { ColorPalette } from 'theme/colors';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  background: #fafafa;
  overflow-y: scroll;
height: 74vh;
padding-right: 20px;
  @media ${({ theme }) => theme.device.mobile} {
    padding-top: 70px;
  }
      &::-webkit-scrollbar {
    width: 6px;
    background-color: ${ColorPalette.HEX.Cultured3};
  }

  &::-webkit-scrollbar-thumb {
    border-radius: 5px;
    box-shadow: inset 0 0 3px rgba(${ColorPalette.RGB.Black}, 0.3);
    background-color: ${ColorPalette.HEX.DavysGrey2};
  }
`;

export const Body = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;

  @media ${({ theme }) => theme.device.mobile} {
    background: #fafafa;
    height: calc(100vh - 80px);
  }
`;

export const FilterTagsContainer = styled.div`
  display: flex;
  align-items: center;
  padding: 0 16px;
  min-height: 50px;
  flex-wrap: wrap;

  @media ${({ theme }) => theme.device.mobile} {
    position: sticky;
    top: 80px;
    background: #fafafa;
    z-index: 1;
    overflow-x: auto;
    flex-wrap: nowrap;
  }

  &:empty {
    display: none;
  }

  &::after {
    content: '';
    min-width: 1px;
    min-height: 1px;
  }
`;

export const Cards = styled.div`
  display: flex;
  flex-wrap: wrap;
  @media ${({ theme }) => theme.device.desktop} {
    margin: 0 6px 110px 16px;
  }
      &::-webkit-scrollbar-track {
    box-shadow: inset 0 0 3px rgba(${ColorPalette.RGB.Black}, 0.3);
    border-radius: 5px;
    background-color: ${ColorPalette.HEX.Cultured3};
  }
`;

export const NotFound: any = styled.h5`
  text-align: center;
  margin: auto 30px;
  padding-bottom: 50px;
  color: ${({ theme }) => theme.flightsList.notFound};
`;

NotFound.Icon = styled(AiOutlineExclamationCircle)`
  margin: 0 auto 15px auto;
  font-size: 25px;
  width: 100%;
`;

export const OneWayIcon = styled(ArrowForw)`
  width: 16px;
  height: 16px;
  margin: 0 5px 0 2px;
`;
export const RoundTripIcon = styled(ArrowTransfer)`
  width: 16px;
  height: 16px;
  margin: 0 5px 0 3px;
`;

export const Wrapper = styled.div``;

export const LeftContainer = styled.div``;

export const SidebarContent = styled.div`
overflow-y: none !important;
`
export const CardsContainer = styled.div`
overflow-y: scroll;
height: 74vh;
padding-right: 20px;
`